import { Box, Flex, Image, Stack, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useQuery } from '@tanstack/react-query';
import { getImages } from '../config/Helper';
import { useEffect, useState } from 'react';
// import { ClamorBlackWhite, LogoText } from '../assets';

interface INotify {
  mainText: string;
  secondText: string;
  icon?: any;
  textColor?: string;
}

type TImages = Awaited<ReturnType<typeof getImages>>;

export const MultipleNotification = ({ mainText, secondText, icon, textColor }: INotify) => {
  const isSmallScreen = useMediaQuery('(max-width: 480px)');
  const [images, setImages] = useState<TImages>([]);

  useEffect(() => {
    async function fetchIndexDBImage() {
      const res = await getImages(['logo', 'logotext', 'no-wifi']);
      setImages(res);
    }

    fetchIndexDBImage();
  }, []);

  return (
    <Flex mih='100vh' w='100%' px='md' justify='center' align='center' direction='column' gap={0}>
      <Stack ta='center' justify='center' align='center'>
        <Image
          width={isSmallScreen ? '130px' : '200px'}
          height={isSmallScreen ? '130px' : '200px'}
          src={images[0]?.url}
        />
        <Image
          width={isSmallScreen ? '150px' : '200px'}
          height={isSmallScreen ? '45px' : '60px'}
          src={images[1]?.url}
        />
        <Text fw={500} mt='sm' c='#bbb'>
          No Chaos ... Only Food
        </Text>
      </Stack>
      <Flex justify='center' align='center' direction='column'>
        {!!mainText && (
          <Text fw={500} fz={isSmallScreen ? '24px' : '35px'} c='white' ta='center'>
            {mainText}
          </Text>
        )}

        {!!secondText && (
          <Text mt='lg' fz={isSmallScreen ? 'md' : 'lg'} c={textColor ? textColor : 'black'} fw={500} ta='center'>
            {secondText}
          </Text>
        )}

        {icon ? (
          <Image
            mt={22}
            width={isSmallScreen ? '56px' : '75px'}
            height={isSmallScreen ? '56px' : '75px'}
            src={images[2]?.url}
          />
        ) : null}
      </Flex>
    </Flex>
  );
};
